import { alpha, Box, IconButton, Typography } from "@mui/material";
import Close from "@mui/icons-material/Close";
import LightbulbOutlined from "@mui/icons-material/LightbulbOutlined";
import { PropsWithChildren } from "react";
import { UIFlag, useUIFlags } from "./UIFlags";

// Hint points out a feature the user may not have found. It shows until the user
// closes it, then never again.
export function Hint(props: PropsWithChildren<{ flag: UIFlag }>) {
    const flags = useUIFlags();
    if (flags.has(props.flag)) return null;

    return (
        <Box sx={{
            display: "flex", alignItems: "flex-start", gap: 1,
            pl: 1.5, pr: 0.5, py: 0.75,
            borderRadius: 1,
            bgcolor: theme => alpha(theme.palette.primary.main, 0.06),
            border: 1, borderColor: theme => alpha(theme.palette.primary.main, 0.2),
        }}>
            <LightbulbOutlined color="primary" sx={{ fontSize: 16, mt: "3px", flexShrink: 0 }} />
            <Typography variant="body2" sx={{ flex: 1, minWidth: 0, fontSize: 13 }}>
                {props.children}
            </Typography>
            <IconButton size="small" aria-label="Close hint" onClick={() => flags.set(props.flag, true)}
                        sx={{ mt: -0.25 }}>
                <Close sx={{ fontSize: 14 }} />
            </IconButton>
        </Box>
    );
}
